import List, { ListOptions, ListComponent } from './Classes/List';

// export default (options: ListOptions, filterData = {}):ListComponent => {
export default (options: ListOptions):ListComponent => {
  return List(options, {
    query: '',
    'dw-state': '',
    'postal-code': '',
    location: '',
  })
};
